import { action } from 'easy-peasy';

const timelineModel = {
  isPlaying: false,
  currentTime: 0,
  timelineDetails: null,
  activeTimelineSlideIndex: 0,
  activeSceneIndexWithinSlide: 0,
  setIsPlaying: action((state, payload) => {
    state.isPlaying = payload;
  }),
  setCurrentTime: action((state, payload) => {
    state.currentTime = payload;
  }),
  setTimelineDetails: action((state, payload) => {
    state.timelineDetails = payload;
  }),
  setActiveTimelineSlideIndex: action((state, payload) => {
    state.activeTimelineSlideIndex = payload;
  }),
  setActiveSceneIndexWithinSlide: action((state, payload) => {
    state.activeSceneIndexWithinSlide = payload;
  })
};

export default timelineModel;
